import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-sos-list-layout',
  templateUrl: './sos-list-layout.component.html',
  styleUrls: ['./sos-list-layout.component.css']
})
export class SosListLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
